import axios from 'axios';

export const getPartyDetail = params => {
  return axios.get('/yongpai-ugc/api/v2/party/detail',{params : params});
};

/*
 生成短链
 */
export const getProduce = params => {
  return axios.get('/yongpai-system/api/word/command/produce/client',{params : params});
};



// WEBPACK FOOTER //
// ./src/api/news/index.js